export const APP_VERSION_SAVE = 'APP_VERSION_SAVE';
export const APP_VERSION_CLEAR = 'APP_VERSION_CLEAR';
